import React from 'react';

const BottomShape = (
  props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>,
) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={27}
      height={13}
      viewBox='0 0 27 13'
      fill='none'
      {...props}
    >
      <g filter='url(#filter0_d_345_1669)'>
        <path d='M27 0H4L27 4.37939V0Z' fill='#FF5612' />
      </g>
      <defs>
        <filter
          id='filter0_d_345_1669'
          x={0}
          y={0}
          width={31}
          height='12.3794'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity={0} result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={2} />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_345_1669'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect1_dropShadow_345_1669'
            result='shape'
          />
        </filter>
      </defs>
    </svg>
  );
};

export default BottomShape;
